import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  margin: 24px 0px;
  gap: 40px;
`;

export const EventsContainer = styled.div`
  max-height: 700px;
  overflow-y: auto;
`;
